import { PREVIEW_CONTEXT_KEY } from '@kurtosys/app-loader/dist/constants/index.js';

import { TPreviewContext } from '../models/TPreviewContext.js';

export function getPreviewContext(applicationCode = ''): TPreviewContext {
	if (window) {
		const keyWithApplicationCode = `${PREVIEW_CONTEXT_KEY}${applicationCode || ''}`;
		if ((window as any)[keyWithApplicationCode]) {
			return (window as any)[keyWithApplicationCode];
		}

		if (!(window as any)[PREVIEW_CONTEXT_KEY]) {
			(window as any)[PREVIEW_CONTEXT_KEY] = {};
		}
		return (window as any)[PREVIEW_CONTEXT_KEY];
	}
}
